import React from 'react'
import colors from '../../../style/colors'
import { PageLoaderWrap } from '../pageLoader/index.styled'
import Loader from '../loaders'
import MainWrapper from '../../MainWrapper'
import PublicHeader from '../../PublicHeader'

const PublicPageLoader = React.memo(({ className }) => {

	return (
		<>
			<PublicHeader />
			<MainWrapper className={className}>
				<PageLoaderWrap>
					<Loader color={colors.blue} zoom={2} />
				</PageLoaderWrap>
			</MainWrapper>
		</>
	)
})

PublicPageLoader.displayName = 'PublicPageLoader'
export default PublicPageLoader
